import { render, staticRenderFns } from "./DialogReservacionPendientePago.vue?vue&type=template&id=080d3e4e"
import script from "./DialogReservacionPendientePago.vue?vue&type=script&lang=js"
export * from "./DialogReservacionPendientePago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports